<template>
  <div class="UserList" ref="use">
    <div class="header">用户推荐明细</div>
  <div v-if="data.datas">
       <van-list
      v-if="data"
      v-model="data.loading"
      :finished="data.finished"
      finished-text="没有更多了"
      @load="onLoad"
    > 
    <div class="user"  v-for="(item,index) in data.datas" :key="index">
       <img :src="item.AvatarUrl" class="userAvaar">
       <div class="userInfo">
          <div class="userName">{{item.NickName}}</div>
          <div class="addTime">{{item.ulog_adddate_format}}</div>
       </div>
      
    </div>
    </van-list>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_id: 29740,
      coupon_id:141,
      data: {
        page: 1,
        channeltype: 0,
        datas: [],
        loading: false,
        finished: false,
      },
    };
  },
  created() {
      console.log("打印",this);
      console.log(this.$route.query.id);
  },

  methods: {
    onLoad() {
      var t = this;
      setTimeout(() => {
         t.data.loading = true;
      t.$http
        .get(
          "/Coupon/RushUserList",
          {
            coupon_no:t.$route.query.no,
            user_id: t.$route.query.id,
            pageindex: t.data.page,
            pagesize: 15,
          },
          2
        )
        .then((res) => {          
          t.data.loading = false;
          console.log("打印res",res.Data);
          if (res.resultState == 1) {
            t.data.datas = t.data.datas.concat(res.Data.datas);
            t.data.page += 1;
            if (res.Data.datas.length < 15) t.data.finished = true;
          } else {
            t.data.finished = true;
            Toast(res.errorMsg);
          }
        //   console.log("t.data.finished", t.data.finished);
        })
        .catch((error) => {});
      }, 800);
    },
  },
};
</script>


<style lang="scss" scoped>
.header {
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.user{
display: flex;
align-items: center;
box-sizing: border-box;
padding: 10px 0;
background-color: #fff;
// margin: 10px 0;
border-bottom: 1px solid #eee;
.userAvaar{
  padding: 5px;
  width: 50px;
  height: 50px;
  border-radius: 10px;
  box-sizing: border-box;
}
.userInfo{
   display: flex;
   flex-direction: column;
   .addTime{
     margin-top: 5px;
     font-size: 12px;
     color: #999;
   }
}
}
</style>